"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerSliderRail = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
const ColorPickerSliderRail = (0, _styled.default)("div")`
    height: 12px;
    border-radius: 6px;
    position: relative;
    cursor: pointer;
    &:focus {
        outline: none;
        &:after {
            content: "";
            position: absolute;
            top: -4px;
            right: -4px;
            bottom: -4px;
            left: -4px;
            display: block;
            border-radius: 10px;
            border: 2px solid ${(0, _designTokensReact.color)("color--border--surfaces--focus")};
            pointer-events: none;
        }
    }
    ${_ref => {
  let {
    color,
    type
  } = _ref;
  return `
     ${type === "color" ? `background: linear-gradient(to right, 
      rgba(255,0,0,1) 0%,
      rgba(255,255,0,1) 16%,
      rgba(0,255,0,1) 33%,
      rgba(0,255,255,1) 50%,
      rgba(0,0,255,1) 66%,
      rgba(255,0,255,1) 83%,
      rgba(255,0,4,1) 100%);` : `background-image: linear-gradient(45deg, ${(0, _designTokensReact.color)("color--background--neutral-inverse--weaker")} 25%, transparent 25%), linear-gradient(-45deg, ${(0, _designTokensReact.color)("color--background--neutral-inverse--weaker")} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${(0, _designTokensReact.color)("color--background--neutral-inverse--weaker")} 75%), linear-gradient(-45deg, transparent 75%, ${(0, _designTokensReact.color)("color--background--neutral-inverse--weaker")} 75%);
      background-size: 10px 10px;
      background-position: 0 0, 0 5px, 5px -5px, -5px 0px;
      &:before{
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: linear-gradient(to right, transparent, ${color});
        border-radius: 6px;
      }
    `}
  `;
}}
`;
exports.ColorPickerSliderRail = ColorPickerSliderRail;
//# sourceMappingURL=ColorPickerSliderRail.js.map